import * as yup from 'yup';

export const commonDocumentIssuanceValidation: { [x: string]: any; } = {
  issueType: yup.string().required("Missing."),
  noOfCopy: yup.number().required("Missing.").min(0, "Input Value should be range from 0 to 99").max(99, "Input Value should be range from 0 to 99"),
  noOfOriginal: yup.number().required("Missing.").min(0, "Input Value should be range from 0 to 99").max(99, "Input Value should be range from 0 to 99"),
  noOfSupportingDoc: yup.number().nullable().min(0, "Input Value should be range from 0 to 99").max(99, "Input Value should be range from 0 to 99"),
  invoiceCurrency: yup.string().required("Missing."),
  docLanguage: yup.string().required("Missing."),
  amountPrinting: yup.string().required("Missing."),
  displayBillingMsg: yup.string().required("Missing."),
  display2ndCurrency: yup.string().required("Missing."),
  reportId: yup.string().required("Missing."),
  asteriskLabel: yup.string().required("Missing."),
  activeInd: yup.string().required("Missing.")
};

export const commonDocumentIssuanceDtlValidation: { [x: string]: any; } = {
  chargeType: yup.string().required("Missing."),
  supportingDoc: yup.string().required("Missing."),
  detailPrinting: yup.string().required("Missing.")
};

export const documentIssuanceValidation: { [x: string]: any; } = {
  ...commonDocumentIssuanceValidation,
};

export const documentIssuanceDtlValidation: { [x: string]: any; } = {
  ...commonDocumentIssuanceDtlValidation,
};

export const DocumentIssuanceValidationSchema = yup.object().shape(documentIssuanceValidation);
export const DocumentIssuanceDtlValidationSchema = yup.object().shape(documentIssuanceDtlValidation);

